import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {
    display: 'flex',
    padding: `${theme.spacing.sm} ${theme.spacing.xl}`,
    boxShadow: theme.shadows.xs,
  },
}))
